module.exports = __webpack_public_path__ + "tl.svg?732dee6e17274508176a900f37b42736";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/tl.svg
// module id = 954
// module chunks = 27